import { useLayoutEffect, useRef, type MutableRefObject } from "react";

/**
 * Mirrors a value into a ref so event handlers and callbacks always observe
 * the latest render's value without needing it in their dependency lists.
 *
 * Syncs in a layout effect so the ref is updated synchronously at commit
 * time — microtasks (e.g. fetch continuations) can never observe a stale
 * value from before the effect flush — and only when the value actually
 * changed, so direct ref writes survive unrelated rerenders.
 */
export function useLatest<T>(value: T): MutableRefObject<T> {
  const ref = useRef(value);
  useLayoutEffect(() => {
    ref.current = value;
  }, [value]);
  return ref;
}
